import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import champs from './taki.fields.json';
import ecrans from './taki.screens.json';
import { importDemoDataset } from './demo-dataset.js';

export const tachesApp = definirAppDeclaree({
  fiche: appInfo,
  champs,
  ecrans,
  demo: { importer: ({ sdk, orgId }) => importDemoDataset(sdk, orgId) },
});

export default tachesApp;
